
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, from } from 'rxjs';
import { UserService } from '../app/secure/_services/user/user.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);

  return from(userService.loadEmployeeInformation()).pipe(
    map((user) => {
      const isAuthenticated = !!user;
      if (isAuthenticated) {
        return true; // Permitir acceso
      } else {
        router.navigate(['/public/login']);
        return false; // Redirigir a la página de acceso no autorizado
      }
    }),
    catchError((err) => {
      console.error('Error in CoordinatorGuard:', err);
      router.navigate(['/public/login']); // Redirigir a la página de inicio de sesión en caso de error});
      return of(false); // Redirigir en caso de error
    })
  );
};